import { UserApiService } from '../core/userApiService';
import * as PARS from '../core';
import { CacheService } from '.';
import { IUser } from 'core/models';

export class UserService {
  private userApiService: UserApiService;

  constructor() {
    this.userApiService = new UserApiService();
  }

  public async getCurrentAsync(): Promise<IUser> {
    const cacheKey: string = PARS.Constants.CACHE_USER_CURRENT;
    const cachedUser: IUser = CacheService.get<IUser>(cacheKey);
    if (cachedUser) {
      return cachedUser;
    }

    const user: IUser = await this.userApiService.getCurrent();
    CacheService.set(cacheKey, user, PARS.Constants.CACHE_USER_CURRENT_EXPIRY_MINS);
    return user;
  }
}
